<template>
  <div>
    <div class="d-none d-lg-block nav-bar">
      <div class="container-fluid">
        <div class="row">
          <div class="container flex align-center">
            <div class="logo col-md-2">
              <img src="../assets/logo.png" alt srcset />
            </div>
            <div class="col-md-8">
              <el-menu
                :default-active="activeIndex"
                text-color="#3E3E3E"
                active-text-color="#0D948A"
                :unique-opened="true"
                menu-trigger="hover"
                mode="horizontal"
                router
                @select="handleSelect"
              >
                <template v-for="item in items">
                  <template v-if="item.subs">
                    <el-submenu :index="item.index" :key="item.index">
                      <template slot="title">
                        <span slot="title">{{item.title}}</span>
                      </template>
                      <template v-for="subItem in item.subs">
                        <el-menu-item :index="subItem.index" :key="subItem.index">{{subItem.title}}</el-menu-item>
                      </template>
                    </el-submenu>
                  </template>
                  <template v-else>
                    <el-menu-item :index="item.index" :key="item.index">
                      <span slot="title">{{item.title}}</span>
                    </el-menu-item>
                  </template>
                </template>
              </el-menu>
            </div>

            <div class="col-md-2 flex align-center phone">
              <img src="../assets/img/phone.png" alt />
              <div class="box flex">
                <span class="tt" :class="isOpacity?'opacity':''">4</span>
                <span class="tt t1" :class="isOpacity?'opacity':''">0</span>
                <span class="tt t2" :class="isOpacity?'opacity':''">0</span>
                <span class="tt t3" :class="isOpacity?'opacity':''">-</span>
                <span class="tt t4" :class="isOpacity?'opacity':''">8</span>
                <span class="tt t5" :class="isOpacity?'opacity':''">0</span>
                <span class="tt t6" :class="isOpacity?'opacity':''">9</span>
                <span class="tt t7" :class="isOpacity?'opacity':''">-</span>
                <span class="tt t8" :class="isOpacity?'opacity':''">0</span>
                <span class="tt t9" :class="isOpacity?'opacity':''">5</span>
                <span class="tt t10" :class="isOpacity?'opacity':''">3</span>
                <span class="tt t10" :class="isOpacity?'opacity':''">2</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="d-lg-none m-nav-bar container-fluid">
      <div class="row">
        <div class="container-fluid">
          <div class="row flex align-center">
            <div class="col-md-7 col-4 logo">
              <img src="../assets/logo.png" alt srcset />
            </div>

            <div class="flex align-center col-md-3 col-5 phone">
              <img src="../assets/img/phone.png" alt />
              <div>400-809-0532</div>
            </div>

            <div class="col-md-2 col-3 icon">
              <div class="flex align-center justify-end btn" @click="open">
                <svg
                  v-if="isOpen == false"
                  class="bi bi-list"
                  viewBox="0 0 16 16"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    d="M2.5 11.5A.5.5 0 0 1 3 11h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 7h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 3h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
                    clip-rule="evenodd"
                  />
                </svg>

                <svg
                  v-if="isOpen == true"
                  class="bi bi-x"
                  width="1em"
                  height="1em"
                  viewBox="0 0 16 16"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    d="M11.854 4.146a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708-.708l7-7a.5.5 0 0 1 .708 0z"
                    clip-rule="evenodd"
                  />
                  <path
                    fill-rule="evenodd"
                    d="M4.146 4.146a.5.5 0 0 0 0 .708l7 7a.5.5 0 0 0 .708-.708l-7-7a.5.5 0 0 0-.708 0z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
            </div>
            <transition name="router-slid">
              <el-col :span="24" v-if="isOpen">
                <el-menu
                  :default-active="activeIndex"
                  active-text-color="#0D948A"
                  @select="handleSelect"
                  router
                >
                  <template v-for="item in items">
                    <template v-if="item.subs">
                      <el-submenu :index="item.index" :key="item.index">
                        <template slot="title">
                          <span slot="title">{{item.title}}</span>
                        </template>
                        <template v-for="subItem in item.subs">
                          <el-menu-item
                            :index="subItem.index"
                            :key="subItem.index"
                          >{{subItem.title}}</el-menu-item>
                        </template>
                      </el-submenu>
                    </template>
                    <template v-else>
                      <el-menu-item :index="item.index" :key="item.index">
                        <i :class="item.icon"></i>
                        <span slot="title">{{item.title}}</span>
                      </el-menu-item>
                    </template>
                  </template>
                </el-menu>
              </el-col>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: "/",
      isOpen: false,
      isOpacity: false,
      items: [
        { title: "首页", index: "/" },
        {
          title: "公司介绍",
          index: "2",
          subs: [
            { title: "公司介绍", index: "/companyIntroduction" },
            { title: "全球市场", index: "/globalMarket" },
            { title: "制造品质", index: "/manufacture" }
          ]
        },
        {
          title: "项目介绍",
          index: "3",
          subs: [
            { title: "雾化站", index: "/site" },
            { title: "雾化器", index: "/wuhua" },
            { title: "布咳乐平台", index: "/bkl" }
          ]
        },
        { title: "招商合作", index: "/inviteInvestment" },
        {
          title: "新闻资讯",
          index: "5",
          subs: [
            { title: "媒体报道", index: "/articleList?type=0" },
            { title: "行业动态", index: "/articleList1?type=1" }
          ]
        },
        // { title: "智能客服", index: "6" }
      ]
    };
  },
  mounted() {
    // localStorage.clear();
    // this.activeIndex = localStorage.getItem("activeIndex");
    setTimeout(() => {
      this.isOpacity = true;
    }, 1000);
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
      // localStorage.setItem("activeIndex", key);
      this.isOpen = !this.isOpen;
    },
    open() {
      this.isOpen = !this.isOpen;
    }
  }
};
</script>

<style>
.el-menu-item,
.el-submenu__title {
  font-size: 16px !important;
}
.el-menu.el-menu--horizontal {
  border: none !important;
}
.el-menu--horizontal > .el-submenu .el-submenu__title {
  height: 80px !important;
  line-height: 80px !important;
}
.el-menu--horizontal > .el-menu-item {
  height: 80px !important;
  line-height: 80px !important;
}

.tt {
  transition: all 3s ease 0s;
  transform: rotate(-0deg);
  float: left;
  opacity: 0;
  color: #0d948a;
}

.opacity {
  opacity: 1;
  /* transform: rotate(-720deg); */
}

.el-menu--collapse .el-menu .el-submenu,
.el-menu--popup {
  min-width: 130px !important;
}

.t1 {
  transition: all 3s ease 0.1s;
}
.t2 {
  transition: all 3s ease 0.2s;
}
.t3 {
  transition: all 3s ease 0.3s;
}
.t4 {
  transition: all 3s ease 0.3s;
}
.t5 {
  transition: all 3s ease 0.5s;
}
.t6 {
  transition: all 3s ease 0.6s;
}
.t7 {
  transition: all 3s ease 0.7s;
}
.t8 {
  transition: all 3s ease 0.8s;
}
.t9 {
  transition: all 3s ease 0.9s;
}
.t10 {
  transition: all 3s ease 1s;
}
</style>

